import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Divider,
  ListItem,
  ListItemText,
} from '@mui/material';
import { OpenInNewOutlined } from '@mui/icons-material';
import { track } from '../analytics';

interface PetResourcesSectionProps {
  awoName: string;
  faqLink?: string;
  adoptionPacketLink?: string;
}

function PetResourcesSection({ awoName, faqLink, adoptionPacketLink }: PetResourcesSectionProps) {
  const hasFaq = Boolean(faqLink);
  const hasAdoptionPacket = Boolean(adoptionPacketLink);

  if (!hasFaq && !hasAdoptionPacket) {
    return null;
  }

  return (
    <Box
      sx={{
        bgcolor: 'white',
        borderRadius: '12px',
        boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.08)',
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Box sx={{ px: 2, py: 1.5, minHeight: '48px' }}>
        <Typography
          variant="h6"
          sx={{ color: 'rgba(0, 0, 0, 0.87)' }}
        >
          Resources from
          {' '}
          {awoName}
        </Typography>
      </Box>

      {hasFaq && (
        <>
          <ListItem
            onClick={() => {
              track('faqs_click');
              window.open(faqLink, '_blank', 'noopener');
            }}
            sx={{ px: 2, py: 0.5 }}
          >
            <ListItemText
              primary="Frequently asked questions"
              primaryTypographyProps={{
                variant: 'body1',
                sx: { color: 'rgba(0, 0, 0, 0.87)' },
              }}
              sx={{ py: 0.5 }}
            />
            <IconButton size="small" sx={{ mr: '-4px' }}>
              <OpenInNewOutlined fontSize="small" />
            </IconButton>
          </ListItem>
          {hasAdoptionPacket && <Divider sx={{ borderColor: 'rgba(238, 238, 238, 1)' }} />}
        </>
      )}

      {hasAdoptionPacket && (
        <ListItem
          button
          onClick={() => {
            track('adoption_packet_view_click');
            window.open(adoptionPacketLink, '_blank', 'noopener');
          }}
          sx={{ px: 2, py: 0.5 }}
        >
          <ListItemText
            primary="Adoption packet"
            primaryTypographyProps={{
              variant: 'body1',
              sx: { color: 'rgba(0, 0, 0, 0.87)' },
            }}
            sx={{ py: 0.5 }}
          />
          <IconButton size="small" sx={{ mr: '-4px' }}>
            <OpenInNewOutlined fontSize="small" />
          </IconButton>
        </ListItem>
      )}
    </Box>
  );
}

export default PetResourcesSection;
